/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";

import { Field } from "formik";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  boxText: {
    fontSize: "12px",
    padding: "5px 10px",
    resize: "vertical",
    maxHeight: "344px",
    "&::placeholder": {
      color: "#717171",
    },
  },
}));

type TProps = {
  question: {
    options: {
      id: number;
      text: string;
      type: string;
    }[];
    id: number;
    text: string;
    mandatory: boolean;
  };
  errorMsg: string | null;
  submitCount: number;
};

function SurveyTextareaInput({ question, errorMsg, submitCount }: TProps) {
  const option = question.options[0];
  const classes = useStyles();
  return (
    <>
      <Field
        aria-invalid={!!errorMsg}
        aria-label={`${question.text} ${question.mandatory ? "*" : ""}`}
        aria-required={question.mandatory}
        aria-describedby={errorMsg ? `error-${question.id}` : undefined}
        component="textarea"
        rows="3"
        className={`form-control utils-fs-12px-imp ${classes.boxText}`}
        name={question.id}
        placeholder={option.text}
      />
      {errorMsg && (
        <span
          id={`error-${question.id}`}
          key={`error-${question.id}-${submitCount}`}
          className="sr-only"
          role="alert"
        >
          {I18n.t("surveys.error", { question: question.text })}
        </span>
      )}
    </>
  );
}

export default SurveyTextareaInput;
